export type LoyerStatut = "a-venir" | "paye" | "en-retard" | "impaye";

export interface Loyer {
  id: string;
  contratId: string;
  immeubleId: string;
  bienId: string;
  locataireId: string;
  /** Période au format `YYYY-MM`. */
  periode: string;
  montant: number;
  /** Date d'échéance `YYYY-MM-DD`. */
  echeance: string;
  statut: LoyerStatut;
  totalPaye: number;
  reste: number;
  joursRetard: number;
}

/** Au-delà de ce nombre de jours de retard, un loyer passe de « En retard » à « Impayé ». */
export const IMPAYE_SEUIL_JOURS = 30;

export const LOYER_STATUT_LABELS: Record<LoyerStatut, string> = {
  "a-venir": "À venir",
  paye: "Payé",
  "en-retard": "En retard",
  impaye: "Impayé",
};

export const LOYER_STATUT_TONES: Record<
  LoyerStatut,
  "primary" | "accent" | "secondary" | "neutral" | "danger" | "success"
> = {
  "a-venir": "neutral",
  paye: "secondary",
  "en-retard": "accent",
  impaye: "danger",
};

export const LOYER_STATUT_OPTIONS = (Object.keys(LOYER_STATUT_LABELS) as LoyerStatut[]).map((value) => ({
  value,
  label: LOYER_STATUT_LABELS[value],
}));

export function isImpaye(statut: LoyerStatut): boolean {
  return statut === "en-retard" || statut === "impaye";
}

/**
 * Modèle de données prévu pour Supabase.
 * Les loyers sont calculés à partir des contrats actifs (une échéance par mois).
 * Table cible : `loyers`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   contrat_id uuid references contrats(id) on delete cascade
 *   immeuble_id uuid, bien_id uuid, locataire_id uuid
 *   periode text (YYYY-MM), montant numeric, echeance date
 *   statut text default 'a-venir'
 * Les statuts sont recalculés automatiquement à partir de la table `paiements`.
 */